export default __webpack_public_path__ + "static/media/azracan6.9a332fec.jpg";